import { css } from '@emotion/react'

export const colors = {
  orange: '#ff5e00',
  orangeBright: '#ff944d',
  orangeDark: '#e56a17',
  scooter: '#2abdbb',
  honeyGold: '#fab818',
  honeyGoldLight: '#ffc94d',
  honeyGoldDark: '#d6990b',
  black: '#000',
  woodsmoke: '#141519',
  shark: '#23252b',
  trout: '#4a4e58',
  scarpaFlow: '#59595b',
  scarpaFlowHiContrast: '#959597',
  scarpaFlowBright: '#989898',
  scarpaFlowLight: '#888',
  silverChalice: '#a0a0a0',
  silver: '#dadada',
  silverDark: '#d3d3d3',
  alabaster: '#f8f8f8',
  white: '#fff',
  blueLighter: '#30434c',
  blueBase: '#213944',
  blueDark: '#121f27',
  crBlueLight: '#2f5161',
  crBlueDark: '#192e38',
  crBlueBright: '#548094',
  pomegranate: '#ef4323',
  heatherField: '#8c8c8c',
}

export const fonts = {
  menu: 'Lato, sans-serif',
  legacy: '"Helvetica Neue", Helvetica, Arial, sans-serif',
  body: 'Lato, "Helvetica Neue", Helvetica, sans-serif',
  crAtyp: 'Crunchyroll Atyp, sans-serif',
  nutmeg: 'Nutmeg, sans-serif',
  nutmegHeadline: 'Nutmeg Headline, sans-serif',
  nutmegBook: 'Nutmeg Book, sans-serif',
  noirPro: 'Noir Pro, sans-serif',
  notoSansJp: 'Noto Sans JP, Lato, sans-serif',
  notoSansThai: 'Noto Sans Thai, Lato, sans-serif',
  notoSansKr: 'Noto Sans KR, Lato, sans-serif',
  notoSansTc: 'Noto Sans TC, Lato, sans-serif',
}

export const focusShadow = css`
  &:focus,
  &:focus-within {
    box-shadow: 0 0 0 0.25rem rgba(160, 160, 160, 0.75) inset;
    outline: 0.125rem solid transparent;
    outline-offset: 0.125rem;
  }

  &:active {
    box-shadow: none;
  }
`

export const focusOutline = css`
  &:focus {
    outline: 0.25rem solid ${colors.silverChalice};
    outline-offset: 0;
  }
`
